import { render, staticRenderFns } from "./m-menu.vue?vue&type=template&id=c68d6c8c&scoped=true"
import script from "./m-menu.vue?vue&type=script&lang=js"
export * from "./m-menu.vue?vue&type=script&lang=js"
import style0 from "./m-menu.vue?vue&type=style&index=0&id=c68d6c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68d6c8c",
  null
  
)

export default component.exports